export const COUNTRY_CODES = [
  { code: '+376', key: 'AD' },
  { code: '+971', key: 'AE' },
  { code: '+93', key: 'AF' },
  { code: '+355', key: 'AL' },
  { code: '+374', key: 'AM' },
  { code: '+244', key: 'AO' },
  { code: '+54', key: 'AR' },
  { code: '+43', key: 'AT' },
  { code: '+61', key: 'AU' },
  { code: '+994', key: 'AZ' },
  { code: '+387', key: 'BA' },
  { code: '+880', key: 'BD' },
  { code: '+32', key: 'BE' },
  { code: '+359', key: 'BG' },
  { code: '+226', key: 'BF' },
  { code: '+257', key: 'BI' },
  { code: '+973', key: 'BH' },
  { code: '+591', key: 'BO' },
  { code: '+55', key: 'BR' },
  { code: '+375', key: 'BY' },
  { code: '+1', key: 'CA' },
  { code: '+237', key: 'CM' },
  { code: '+56', key: 'CL' },
  { code: '+86', key: 'CN' },
  { code: '+57', key: 'CO' },
  { code: '+506', key: 'CR' },
  { code: '+53', key: 'CU' },
  { code: '+357', key: 'CY' },
  { code: '+420', key: 'CZ' },
  { code: '+49', key: 'DE' },
  { code: '+45', key: 'DK' },
  { code: '+213', key: 'DZ' },
  { code: '+20', key: 'EG' },
  { code: '+503', key: 'SV' },
  { code: '+372', key: 'EE' },
  { code: '+34', key: 'ES' },
  { code: '+251', key: 'ET' },
  { code: '+358', key: 'FI' },
  { code: '+33', key: 'FR' },
  { code: '+44', key: 'GB' },
  { code: '+995', key: 'GE' },
  { code: '+233', key: 'GH' },
  { code: '+30', key: 'GR' },
  { code: '+502', key: 'GT' },
  { code: '+504', key: 'HN' },
  { code: '+385', key: 'HR' },
  { code: '+36', key: 'HU' },
  { code: '+62', key: 'ID' },
  { code: '+91', key: 'IN' },
  { code: '+353', key: 'IE' },
  { code: '+972', key: 'IL' },
  { code: '+964', key: 'IQ' },
  { code: '+98', key: 'IR' },
  { code: '+354', key: 'IS' },
  { code: '+39', key: 'IT' },
  { code: '+81', key: 'JP' },
  { code: '+962', key: 'JO' },
  { code: '+254', key: 'KE' },
  { code: '+996', key: 'KG' },
  { code: '+855', key: 'KH' },
  { code: '+82', key: 'KR' },
  { code: '+965', key: 'KW' },
  { code: '+371', key: 'LV' },
  { code: '+961', key: 'LB' },
  { code: '+94', key: 'LK' },
  { code: '+370', key: 'LT' },
  { code: '+352', key: 'LU' },
  { code: '+218', key: 'LY' },
  { code: '+212', key: 'MA' },
  { code: '+377', key: 'MC' },
  { code: '+373', key: 'MD' },
  { code: '+389', key: 'MK' },
  { code: '+976', key: 'MN' },
  { code: '+52', key: 'MX' },
  { code: '+60', key: 'MY' },
  { code: '+258', key: 'MZ' },
  { code: '+234', key: 'NG' },
  { code: '+505', key: 'NI' },
  { code: '+31', key: 'NL' },
  { code: '+47', key: 'NO' },
  { code: '+977', key: 'NP' },
  { code: '+64', key: 'NZ' },
  { code: '+507', key: 'PA' },
  { code: '+92', key: 'PK' },
  { code: '+595', key: 'PY' },
  { code: '+51', key: 'PE' },
  { code: '+63', key: 'PH' },
  { code: '+48', key: 'PL' },
  { code: '+351', key: 'PT' },
  { code: '+974', key: 'QA' },
  { code: '+40', key: 'RO' },
  { code: '+381', key: 'RS' },
  { code: '+7', key: 'RU' },
  { code: '+966', key: 'SA' },
  { code: '+221', key: 'SN' },
  { code: '+46', key: 'SE' },
  { code: '+65', key: 'SG' },
  { code: '+421', key: 'SK' },
  { code: '+386', key: 'SI' },
  { code: '+503', key: 'SV' },
  { code: '+27', key: 'ZA' },
  { code: '+41', key: 'CH' },
  { code: '+886', key: 'TW' },
  { code: '+66', key: 'TH' },
  { code: '+90', key: 'TR' },
  { code: '+380', key: 'UA' },
  { code: '+256', key: 'UG' },
  { code: '+1', key: 'US' },
  { code: '+598', key: 'UY' },
  { code: '+998', key: 'UZ' },
  { code: '+58', key: 'VE' },
  { code: '+84', key: 'VN' },
  { code: '+967', key: 'YE' },
  { code: '+260', key: 'ZM' },
  { code: '+263', key: 'ZW' }
];
